import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useRootStore } from 'core/hooks/use-root-store';
import { RAuthStore } from './r-auth.store';

const RAuthContext = React.createContext<RAuthStore | null>(null);

export const RAuthProvider = ({ children }: { children: ReactNode }) => {
   const rootStore = useRootStore();
   const { i18n } = useTranslation('global');

   const selectedLanguage = Cookies.get('selectedLanguage') || i18n.language || 'ukr';
   const apiLanguage = selectedLanguage === 'ukr' ? 'uk' : selectedLanguage;

   const [store] = React.useState<RAuthStore>(() => new RAuthStore(rootStore, apiLanguage));

   return <RAuthContext.Provider value={store}>{children}</RAuthContext.Provider>;
};

export const useRAuth = (): RAuthStore => {
   const ctx = React.useContext(RAuthContext);
   if (!ctx) {
      throw new Error('useRAuth must be used inside RAuthProvider');
   }
   return ctx;
};
